import { Employee } from './../../models/employee.model';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { countries } from 'src/app/resources/countries';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { Team } from 'src/app/models/team.model';
import { Enum } from 'src/app/models/enum.model';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { ApiService } from 'src/app/services/http/api.service';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { IntlService } from '@progress/kendo-angular-intl';
import { Profiles } from 'src/app/utils/profiles';
import { Entity } from 'src/app/models/entity.model';
import { User } from 'src/app/global-functions';

@Component({
    selector: 'app-users-form-component',
    templateUrl: './users-form.component.html'
})
export class UsersFormComponent extends DialogContentBase implements OnInit {
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public formGroup: FormGroup = new FormGroup({});
    public countries = countries;
    public phoneNumberMask = '(+9) 0000-000-00-00';
    public fileRestrictions: FileRestrictions = { allowedExtensions: ['.png', '.jpeg', '.jpg'] };
    public avatars?: NodeList;
    public listItemsEquipas: Array<Team> = [];
    public listItemsLinguas: Array<Enum> = [];
    public listItemsPerfil: Array<Enum> = [];
    public perfis = Profiles;
    public selectedTeams: any[] = [];
    public listItemsEntidades: Array<Entity> = [];
    public formValue: Employee = {
        id: 0,
        nome: '',
        email: '',
        telemovel: '',
        idLingua: 1,
        lingua: '',
        nomesEquipas: [],
        idCartao: '',
        codigoDeFuncionario: '',
        idFuncao: this.perfis.Colaborador,
        externo: false,
        funcao: '',
        iDsEquipas: [],
        canEdit: false,
        refEntidade: 0,
        nomeEntidade: '',
        idSolucaoEntidade: 0,
        corPrincipalEntidade: '',
        corSecundariaEntidade: '',
        refLogoEntidade: 0,
    };
    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService, private notificationService: NotificationService, private api: ApiService, public override dialog: DialogRef, private intl: IntlService) {
        super(dialog);

        this.customMsgService = this.msgService as CustomMessagesService;
        this.placeHolderEntidade.nome = this.customMsgService.translate('selecionartag');
        this.api
            .getRequest<BaseHttpResponse<Team[]>>("Equipa/GetEquipas")
            .then((data) => {
                this.listItemsEquipas = data.value;
            })
            .catch((err) => { });

        var objs = undefined;

        if (this.formValue?.refEntidade != 0) {
            objs = { id: this.formValue?.refEntidade }
        }

        this.formGroup = new FormGroup({
            nome: new FormControl(this.formValue?.nome, [Validators.required]),
            telemovel: new FormControl(this.formValue?.telemovel),
            idCartao: new FormControl(this.formValue?.idCartao, [Validators.required]),
            idFuncao: new FormControl({ id: this.formValue?.idFuncao }, [Validators.required]),
            iDsEquipas: new FormControl([]),
            refEntidade: new FormControl(objs),
            idLingua: new FormControl({ id: this.formValue?.idLingua }, [Validators.required]),
            validade: new FormControl(),
            codigoDeFuncionario: new FormControl(this.formValue?.codigoDeFuncionario),
            email: new FormControl(this.formValue?.email)
        });
    }

    public placeHolderEntidade: any = {
        nome: "",
        id: undefined,
    }

    ngOnInit() {
        this.api
            .getRequest<BaseHttpResponse<Entity[]>>("Entidade/GetEntidades")
            .then((data) => {
                this.listItemsEntidades = data.value;
            })
            .catch((err) => { });

        this.api
            .getRequest<BaseHttpResponse<Team[]>>("Equipa/GetEquipas")
            .then((data) => {
                this.listItemsEquipas = data.value;

                var ids = this.formValue.iDsEquipas.map(a => a);
                var lll = this.listItemsEquipas.filter(x => ids.find(f => f === x.id));
                this.formGroup.controls['iDsEquipas'].setValue(lll);

            })
            .catch((err) => { });

        this.api
            .getRequest<BaseHttpResponse<Enum[]>>("Utilizador/GetCargos")
            .then((data) => {
                this.listItemsPerfil = data.value;

            })
            .catch((err) => { });

        this.api
            .getRequest<BaseHttpResponse<Enum[]>>("Utilizador/GetLinguas")
            .then((data) => {
                this.listItemsLinguas = data.value;

            })
            .catch((err) => { });
    }
    public setFormValues() {

        var ids = this.formValue.iDsEquipas.map(a => a);
        var lll = this.listItemsEquipas.filter(x => ids.find(f => f === x.id));
        var objs = undefined;
        if (this.formValue?.refEntidade != 0) {
            objs = { id: this.formValue?.refEntidade }
        }
        this.formGroup = new FormGroup({
            nome: new FormControl(this.formValue?.nome, [Validators.required]),
            telemovel: new FormControl(this.formValue?.telemovel),
            idCartao: new FormControl(this.formValue?.idCartao, [Validators.required]),
            idFuncao: new FormControl({ id: this.formValue?.idFuncao }, [Validators.required]),
            iDsEquipas: new FormControl(lll),
            refEntidade: new FormControl(objs),
            idLingua: new FormControl({ id: this.formValue?.idLingua }, [Validators.required]),
            validade: new FormControl(),
            codigoDeFuncionario: new FormControl(this.formValue?.codigoDeFuncionario),
            email: new FormControl(this.formValue?.email),
        });

        this.formGroup.controls['iDsEquipas'].clearValidators();
        if (this.formValue.validade)
            {this.formGroup.controls['validade'].setValue(new Date(this.formValue.validade));
        this.formGroup.controls['email'].clearValidators()
        this.formGroup.controls['iDsEquipas'].clearValidators()}

        if (
            this.formValue?.idFuncao != this.perfis.Administrador &&
            this.formValue?.idFuncao != this.perfis.Manutencao &&
            this.formValue?.idFuncao != this.perfis.RespFerramentas &&
            this.formValue?.idFuncao != this.perfis.Diretor) {
            this.formGroup.controls['iDsEquipas'].setValidators([Validators.required]);
        }
        //this.formGroup.controls['email'].updateValueAndValidity();

        this.formGroup.controls['iDsEquipas'].updateValueAndValidity();
    }
/* 
    public selectionChangeEmail(value: any): void {
        // Define o e-mail como obrigatório apenas se NÃO for 'Colaborador'
        if (value.id !== this.perfis.Colaborador) {
            this.formGroup.controls['email'].setValidators([Validators.required]);
        } else {
            this.formGroup.controls['email'].clearValidators();
        }
        // Atualiza as validações para o campo de e-mail
        this.formGroup.controls['email'].updateValueAndValidity();
    } */

    //* calidar este campo 
    public selectionChangeEntidade(value: any): void {
        // Define a entidade como obrigatório apenas se NÃO for 'Administrador-Geral'
        if (value.id !== this.perfis.AdministradorGeral) {
            this.formGroup.controls['refEntidade'].setValidators([Validators.required]);
        } else {
            this.formGroup.controls['refEntidade'].clearValidators();
        }
        // Atualiza as validações para o campo de entidade
        this.formGroup.controls['refEntidade'].updateValueAndValidity();
    }

    public selectionChangeEquipas(value: any): void {
        // Configura a necessidade das equipes apenas se for diferente de certos perfis
        if (value.id == this.perfis.Diretor || value.id == this.perfis.Manutencao || value.id == this.perfis.RespFerramentas 
            || value.id == this.perfis.Colaborador || value.id == this.perfis.Supervisor || value.id == this.perfis.Repositor || value.id == this.perfis.Limpeza) {
            this.formGroup.controls['iDsEquipas'].setValidators([Validators.required]);
        } else {
            this.formGroup.controls['iDsEquipas'].clearValidators();
        }
        // Atualiza as validações para o campo de equipes
        this.formGroup.controls['iDsEquipas'].updateValueAndValidity();
    }

    public selectionChangeEmail(value: any): void {
        if(value.id === this.perfis.Administrador || value.id === this.perfis.AdministradorGeral){
            this.formGroup.controls['email'].setValidators([Validators.required]);
        }
        else{
            this.formGroup.controls['email'].clearValidators();
        }
        this.formGroup.controls['email'].updateValueAndValidity();
    }


    public saveChanges(): void {
        this.formGroup.markAllAsTouched();
        this.formGroup.markAsPristine();

        var ar: Array<Team> = this.formGroup.controls['iDsEquipas'].value;

        this.formValue.nome = this.formGroup.controls['nome'].value;
        this.formValue.email = this.formGroup.controls['email'].value;
        this.formValue.telemovel = this.formGroup.controls['telemovel'].value;
        this.formValue.idLingua = this.formGroup.controls['idLingua'].value.id;
        this.formValue.validade = this.formGroup.controls['validade'].value;
        this.formValue.codigoDeFuncionario = this.formGroup.controls['codigoDeFuncionario'].value;
        this.formValue.idFuncao = this.formGroup.controls['idFuncao'].value.id;
        this.formValue.idCartao = this.formGroup.controls['idCartao'].value;
        this.formValue.externo = false;
        this.formValue.refEntidade = this.formGroup.controls['refEntidade'].value.id;

        this.formValue.iDsEquipas = ar.map(a => a.id)

        this.api.save<BaseHttpResult>('Utilizador/SaveUtilizador', this.formValue).then(res => {
            if (res.ok) {
                //this.formGroup.markAsPristine();
                this.dialog.close();

                this.notificationService.show({
                    content: this.customMsgService.translate('registoGravadoComSucesso'),
                    animation: { type: 'slide', duration: 500 },
                    position: { horizontal: 'center', vertical: 'bottom' },
                    type: { style: 'success', icon: true },
                    hideAfter: 2000
                });
            } else {
                this.notificationService.show({
                    appendTo: this.container,
                    content: res.message,
                    animation: { type: 'slide', duration: 500 },
                    position: { horizontal: 'center', vertical: 'top' },
                    type: { style: 'error', icon: true },
                    hideAfter: 4000
                });
            }
        });
    }

    infoEmail(){
        var text="";
        text += "Insira este campo caso pretenda que o utilizador receba um email para definir uma password de acesso ao backoffice";
        return text;
    }

    cargos() {
        //Get user in session
        var user = User.userInSession();

        //Get user solution
        var idSolucao = user.IDSolucaoEntidade;

        var text = "";

        if (idSolucao == 1) {
            text += "Administrador: pessoa ou entidade autorizada a realizar qualquer operação. \n\n";
            text += "Diretor: responsável pela gestão da solução num determinado Local/Departamento. \n\n";
            text += "Supervisor: responsável por gerir uma ou mais Equipas de Colaboradores. \n\n";
            text += "Colaborador: utilizador que fará uso dos artigos. \n\n";
            text += "Repositor: responsável por assegurar a reposição dos artigos nos Armários. \n\n";
            text += "Manutenção: responsável pela instalação e manutenção dos Armários. \n\n";
            text += "Limpeza: responsável pela higienização dos Armários.";
        } else if (idSolucao == 2) {
            text += "Administrador: pessoa ou entidade autorizada a realizar qualquer operação. \n\n";
            text += "Diretor: responsável pela gestão da solução num determinado Local/Departamento. \n\n";
            text += "Supervisor: responsável por gerir uma ou mais Equipas de Colaboradores. \n\n";
            text += "Colaborador: utilizador que fará uso das Ferramentas. \n\n";
            text += "Resp. Ferramentas: responsável pela manutenção do parque de Ferramentas. \n\n";
            text += "Manutenção: responsável pela instalação e manutenção dos Armários.";
        } else if (idSolucao == 3) {
            text += "Administrador: pessoa ou entidade autorizada a realizar qualquer operação. \n\n";
            text += "Supervisor: responsável por auxiliar os clientes a operar os Armários. \n\n";
            text += "Manutenção: responsável por garantir o correto funcionamento dos Armários. \n\n";
            text += "Higienização: responsável pela higienização dos Armários.\n\n";
            text += "Cliente: pessoa que utiliza os cacifos para armazenar bens pessoais.";
        }
        return text;

    }

    public cancelChanges(): void {
        this.setFormValues();
    }

}
